import { appColors } from '@backrs_ui/common-ui';

import { appStrings } from '@backrs_ui/grow-ui/src/assets/appStrings';

import { Box, Typography, RadioGroup } from '@mui/material';
import { SxProps, Theme } from '@mui/system';

import { ProficiencyLevelRadioGroup } from '../atoms/ProficiencyLevelRadioGroup';

const COMPETENCY_STRINGS = appStrings.modules.competency;

type ProficiencyLevelDialogProps = Readonly<{
  currentProficiencyLevel: number;
  handleProficiencyChange: (newProficiencyLevel: number) => void;
}>;

export const ProficiencyLevelDialog = ({
  currentProficiencyLevel,
  handleProficiencyChange,
}: ProficiencyLevelDialogProps) => {
  return (
    <Box>
      <Typography sx={titleStyle}>{COMPETENCY_STRINGS.proficiency.modalTitle}</Typography>
      <Box sx={contentContainerStyles}>
        <RadioGroup
          value={currentProficiencyLevel}
          onChange={(event) => handleProficiencyChange(parseInt(event.target.value))}
          sx={radioGroupStyles}
        >
          <ProficiencyLevelRadioGroup
            value={0}
            content={{
              title: COMPETENCY_STRINGS.proficiency.basic.title,
              description: COMPETENCY_STRINGS.proficiency.basic.description,
              icon: 'ModuleUncompleted',
              iconAlt: 'Uncompleted',
            }}
          />
          <ProficiencyLevelRadioGroup
            value={1}
            content={{
              title: COMPETENCY_STRINGS.proficiency.advanced.title,
              description: COMPETENCY_STRINGS.proficiency.advanced.description,
              icon: 'ModuleLevelOne',
              iconAlt: 'Level One',
            }}
          />
          <ProficiencyLevelRadioGroup
            value={2}
            content={{
              title: COMPETENCY_STRINGS.proficiency.expert.title,
              description: COMPETENCY_STRINGS.proficiency.expert.description,
              icon: 'ModuleLevelTwo',
              iconAlt: 'Level Two',
            }}
          />
        </RadioGroup>
      </Box>
    </Box>
  );
};

const contentContainerStyles: SxProps<Theme> = {
  px: 4,
  pb: 3,
};

const radioGroupStyles: SxProps<Theme> = {
  mt: 2,
  gap: 4,
};

const titleStyle: SxProps<Theme> = {
  backgroundColor: appColors.color.blue4,
  p: 3,
  justifyContent: 'center',
  alignItems: 'center',
  display: 'flex',
  flexDirection: 'row',
  fontWeight: 700,
  color: appColors.color.blue1,
  fontSize: 28,
  fontFamily: 'Sarabun',
  '@media (max-width: 600px)': {
    fontSize: 20,
  },
};
